const TAB_ITEMS = [
  { value: "personal", label: "PERSONAL", count: 4 },
  { value: "news", label: "NEWS_PROMOTION", count: 3 },
];

export default TAB_ITEMS;
